import { ArticleSection } from "./ArticleSection";

import { Receipt, ExtendedViewItem } from "@/types/receipt";
import { translate } from "@/utils/formatters";
import { PopupArticle } from "@/constants/popup";

interface ArticlesSectionProps {
  receipt: Receipt;
  lang: string;
  openPopup: (type: string, index?: number, article?: PopupArticle) => void;
  extended_view_items?: ExtendedViewItem[];
  extended_view_images?: { [key: string]: string };
  user_id: string;
  receipt_id: string;
  email?: string | null;
  phoneNumber?: string | null;
}

export const ArticlesSection = ({
  receipt,
  lang,
  openPopup,
  extended_view_items,
  extended_view_images,
  user_id,
  receipt_id,
  email,
  phoneNumber,
}: ArticlesSectionProps) => {
  if (!receipt.articles) return null;

  return (
    <>
      <div className="box head">
        <div className="split">
          <h5>
            <span>{translate(lang, "Artikkel", "Article")}</span>
          </h5>
          <h5>
            <span>{translate(lang, "Beløp", "Sum")}</span>
          </h5>
        </div>
      </div>

      {receipt.articles.map((article, index) => (
        <ArticleSection
          key={"article-" + index}
          index={index}
          article={article}
          lang={lang}
          receipt={receipt}
          openPopup={openPopup}
          extended_view_items={extended_view_items}
          extended_view_images={extended_view_images}
          user_id={user_id}
          receipt_id={receipt_id}
          email={email}
          phoneNumber={phoneNumber}
        />
      ))}
    </>
  );
};
